export const en = {
    "k_85a2ac6d": "CosId does not exist",
    "k_bd294cfd": "[npm-loader] Initialization failed: {arg_0}",
    "k_ffa5d2bf": "❌ Unable to find a dependent package for the specified version: {arg_0}",
    "k_20c05d43": "❌ Unable to find a dependent package for the specified version",
    "k_aa091d87": "❌ The requested dependency package version does not exist",
    "k_913cb600": "❌ The specified dependency cannot be found. Please check whether the package name is wrong",
    "k_afa3a043": "📦Installing dependency packages...",
    "k_ef816546": "❌ Dependent package installation failed",
    "k_6563763f": "⚡ Packaging dependent files...",
    "k_a8bff7e6": "❌ Packaging of dependent files failed",
    "k_10cb4715": "✅ Depends on updates to complete",
    "k_dfd0126d": "❌ Dependent update failed",
    "k_daa8324c": "Processing...",
    "k_993229d6": "WUJI blue",
    "k_a9ccf0cc": "Dependency update failed, please check whether the external package name is wrong",
    "k_c8ddc835": "Cannot find the dependency \"{arg_0}\". Please check whether the package name is wrong",
    "k_bf230c2f": "Dependent loading",
    "k_cc62b75c": "Dependency loading successfully",
    "k_95a6aab0": "Dependency updates...",
    "k_471da1da": "Language",
    "k_a6caebd4": "Failed to obtain language configuration:"
};
